import axios, { type AxiosInstance } from 'axios';
import mime from "mime"
import { cookies } from 'src/helpers';

interface GetParams {
	page?: number;
	pageSize?: number;
}
export default class Service {
	private readonly pathname: string;
	service: AxiosInstance;
	constructor(path: string) {
		this.pathname = `/${path}`;
		this.service = axios.create({ baseURL: process.env.REACT_APP_API_URL });

		// NOTE:
		// ./src/modules/Private/Courses/Course.tsx[22:8]
		this.service.interceptors.request.use(async (config: any) => {
			// const credentials = cookies.get("auth");
			// if (credentials) {
			config.headers.Authorization = `Bearer ${cookies.get('auth')}`;
			return config;
			// } else {
			//     window.location.reload();
			//     throw new axios.Cancel("Operation canceled");
			// }
		});

		this.createPath = this.createPath.bind(this);
		this.getAll = this.getAll.bind(this);
		this.getOne = this.getOne.bind(this);
		this.getPath = this.getPath.bind(this);
		this.create = this.create.bind(this);
		this.createPath = this.createPath.bind(this);
		this.update = this.update.bind(this);
		this.updatePath = this.updatePath.bind(this);
		this.delete = this.delete.bind(this);
		this.downloadLayout = this.downloadLayout.bind(this);
		this.downloadReport = this.downloadReport.bind(this);
	}

	async getAll({ page, pageSize }: GetParams) {
		const response = await this.service.get(this.pathname, {
			params: { page, pageSize },
		});
		return response.data;
	}

	async getOne(id: number | string) {
		const response = await this.service.get(`${this.pathname}/${id}`);
		return response;
	}

	async getPath(path: string) {
		const response = await this.service.get(`${this.pathname}/${path}`);
		return response;
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	async create(post: any) {
		const response = await this.service.post(this.pathname, post);
		return response;
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	async createPath(path: string, post: any) {
		const response = await this.service.post(
			`${this.pathname}/${path}`,
			post,
		);
		return response;
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	async update(post: any) {
		const response = await this.service.put(this.pathname, post);
		return response;
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	async updatePath(path: string, post: any) {
		const response = await this.service.put(
			`${this.pathname}/${path}`,
			post,
		);
		return response;
	}

	async delete(id: number | string) {
		const response = await this.service.delete(`${this.pathname}/${id}`);
		return response;
	}

	async downloadLayout() {
		await axios({
			url: `${process.env.REACT_APP_API_URL}${this.pathname}/download_layout`,
			method: 'GET',
			responseType: 'blob',
			headers: {
				Authorization: 'Bearer ' + cookies.get('auth'),
			},
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `Layout_Cursos.xlsx`);
			document.body.appendChild(link);
			link.click();
		});
	}

	async downloadReport(path: string, type: string, courseName: string) {
		await axios({
			url: `${process.env.REACT_APP_API_URL}${this.pathname}/${path}`,
			method: 'GET',
			responseType: 'blob',
			headers: {
				Authorization: 'Bearer ' + cookies.get('auth'),
			},
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute(
				'download',
				`${type === 'advances'
					? 'Bitácora de avance'
					: 'Reporte calificaciones'
				} - ${courseName}.xlsx`,
			);
			document.body.appendChild(link);
			link.click();
		});
	}

	download = async (path: string, filename: string, headers?: any, options?: {
		disableMimeType?: boolean
	}) => {
		await this.service
			.get(`${this.pathname}/${path}`, { responseType: 'blob', headers })
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));

				const _filename = options?.disableMimeType
					? filename
					// @ts-ignore
					: `${(filename.substring(0, filename.lastIndexOf('.'))) || filename}.${mime.getExtension(response.data?.type)}`

				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', _filename);
				document.body.appendChild(link);
				link.click();
			});
	};

	get headers() {
		return {
			authorization: `Bearer ${cookies.get('auth')}`,
		};
	}
}
